import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import {
  constructUrl,
  getGroupUrl
} from "@pathwright/web/src/modules/utils/urls"
import { ConnectStores } from "lib/core/store"
import PropTypes from "prop-types"
import "./MemberControls.css"

const MemberControls = (props) => {
  const {
    member,
    showEmail,
    selectMemberForRemoval,
    canManageRegistration,
    toMemberConfiguration
  } = props
  const { t } = useTranslate()
  const { user } = member

  if (!showEmail && !canManageRegistration && !canManageRegistration) {
    return null
  }

  return (
    <DropdownMenu closeOnClick>
      {showEmail && (
        <DropdownItem
          icon="envelope"
          label={user.email}
          href={`mailto:${user.email}`}
        />
      )}
      {canManageRegistration && (
        <DropdownItem
          icon="gear"
          label="Configure registration"
          to={toMemberConfiguration}
        />
      )}
      {canManageRegistration && (
        <DropdownItem
          icon="slash"
          label={`Remove from ${t("cohort.label")}`}
          onClick={selectMemberForRemoval}
        />
      )}
    </DropdownMenu>
  )
}

MemberControls.displayName = "MemberControls"

MemberControls.propTypes = {
  showEmail: PropTypes.bool
}

MemberControls.defaultProps = {
  showEmail: true
}

const mapStateToProps = (state, ownProps) => {
  const { member } = ownProps
  const { registration, offering, resource, section } =
    state.resourceStore.state
  const { permissions } = state.schoolStore.state

  const canManageRegistration =
    (registration && registration.role >= member.role) ||
    (offering && offering.permissions.can_edit_resource) ||
    (permissions &&
      (permissions.user_is_school_editor || permissions.user_is_school_admin))

  const selectMemberForRemoval = (props) => {
    canManageRegistration &&
      state.memberStore.action.selectMemberForRemoval(member.id)
  }

  const toMemberConfiguration = constructUrl(
    getGroupUrl(resource.slug, offering.id, section),
    `/member/registration/${member.id}/`
  )

  return _.assign(
    {},
    {
      selectMemberForRemoval,
      canManageRegistration,
      toMemberConfiguration
    },
    ownProps
  )
}

const stores = [
  { store: "member", watch: false },
  {
    store: "resource",
    watch: false
  },
  {
    store: "school",
    watch: "permissions"
  }
]

export default ConnectStores(MemberControls, stores, {}, mapStateToProps)
